import $api from "@/frontend/shared/api/axios";

export enum EErrorType {
  TECHNICAL = "Technical",
  CONTENT_RELATED = "ContentRelated",
  OTHER = "Other"
}

export async function postReportError({
  description,
  type,
  id
}: {
  description: string;
  type: EErrorType;
  id: number;
}) {
  await $api.post(`/portfolio-companies/${id}/report-error`, { description, errorType: type });
}
